import { checkSendStatus, smsTemplateContent } from '@/api/workPlace/SMS'
import { reactive, ref } from 'vue'

export function useSMS() {
  const smsDOM = ref()
  const canSend = ref(false)
  // 渲染大纲的类目 titles
  const outline1 = reactive({
    title: [],
    value: null,
    component: ''
  })
  const outline2 = reactive({
    title: [],
    value: null,
    component: ''
  })
  const outline3 = reactive({
    title: [],
    value: null,
    component: ''
  })
  // 获取模版大纲
  function getOutline() {}
  // 发送前的判断
  const sendBefore = (role, ucUserId) =>
    new Promise(resolve => {
      checkSendStatus({ role, ucUserId }).then(result => {
        canSend.value = result.code === 0
        resolve(result)
      })
    })
  // 获取模版消息
  const smsTemplate = (type, parentId, doctorUcId, hospitalId) =>
    new Promise(resolve => {
      smsTemplateContent({
        parentId,
        type,
        templateParas: { doctorUcId, hospitalId }
      }).then(result => {
        resolve(result)
      })
    })
  return { canSend, smsDOM, outline1, outline2, outline3, sendBefore, getOutline, smsTemplate }
}
